import React, { Fragment, useEffect, useState } from "react";
import Closemodal from "icons/Closemodal";
import { Bit } from "types/types";
import { CheckUserRequest, UserInvitationRequest } from "../services/services";
import { notifySuccess } from "pages/Errors/Error";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import GiftBitPaymentForm from "./GiftBitPaymentForm";
import { Paymentsuccessful } from "pages/payment/components/Paymentsuccessful";
import { Paymentfailed } from "pages/payment/components/Paymentfailed";
import { GiftPaymentsuccessful } from "./GiftPaymentSuccess";

interface GiftBitPopupProps {
  loggedUserPurchasedBitInfo: Bit[] | null;
  setGiftBitPopup: Function;
  //   setShowPaymentPopUp: Function;
}
export const GiftBitPopup: React.FC<GiftBitPopupProps> = ({
  loggedUserPurchasedBitInfo,
  setGiftBitPopup,
  //   setShowPaymentPopUp,
}) => {
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [checkUserData, setCheckUserData] = useState<any>(null);
  const [formStep, setFormStep] = useState<string>("step1");

  const [selectedValue, setSelectedValue] = useState<string>();
  const [receiverUserId, setReceiverUserId] = useState<any>();

  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null>>(
    Promise.resolve(null)
  );

  const [paymentCompleted, setPaymentCompleted] = useState<boolean>(false);
  const [paymentFailed, setPaymentFailed] = useState<boolean>(false);
  const [transactionId, setTransactionId] = useState<null | string>(null);
  const [transactionAmount, setTransactionAmount] = useState<null | string>(
    null
  );

  const handleNext = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || email.trim() === "" || !emailPattern.test(email.trim())) {
      setMessage("*Please enter a valid email address!");
      return;
    }
    try {
      setLoading(true);
      setMessage("");

      // registerRequest(values, setErrors, setSubmitting)
      const data = {
        email: email.trim(),
      };
      CheckUserRequest(data).then((res: any) => {
        if (res.success) {
          if (res?.data?.is_registered === true) {
            setCheckUserData(res?.data);
            setReceiverUserId(res?.data?.user_id);
            setFormStep("step3");
          } else {
            setCheckUserData(res?.data);
            setMessage(
              "User isn’t registered yet, You want to send them an invitation link ?."
            );
          }
        } else {
          setMessage("Something went wrong.");
        }
      });
    } catch (error: any) {
      setMessage(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleEmailChange = async (e: any) => {
    try {
      setMessage("");
      setCheckUserData(null);
      setEmail(e.target.value);
    } catch (error: any) {
      setMessage("Something went wring");
    }
  };

  const sendInvitationHandle = async () => {
    try {
      setLoading(true);
      setMessage("");
      const data = {
        email: email.trim(),
      };
      UserInvitationRequest(data).then((res: any) => {
        if (res?.success) {
          notifySuccess("Invitation email sent successfully.");
          setCheckUserData(null);
        } else {
          setMessage("Something went wrong.");
        }
      });
    } catch (error: any) {
      setMessage(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setMessage("");
    setSelectedValue(e.target.value);
  };

  const handleNextStep1 = () => {
    if (!selectedValue) {
      setMessage("Please select a Bit to gift");
      return;
    }
    setFormStep("step2");
  };

  const getStripe = async () => {
    try {
      const publishable_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
      const stripeInstance = await loadStripe(publishable_key as string);

      setStripePromise(Promise.resolve(stripeInstance));
    } catch (error) {
      console.error("Stripe initialization error:", error);
      setStripePromise(Promise.resolve(null));
    }
  };

  useEffect(() => {
    if (formStep === "step3") {
      getStripe();
    }
  }, [formStep]);

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-black/70 backdrop-blur-md z-999 flex items-center justify-center px-4">
        <div className="bg-white max-w-[90%] min-w-[90%] md:max-w-600px md:min-w-600px p-5  rounded-xl z-50 space-y-3 relative">
          <div className="flex items-center justify-between border-b border-black/10 pb-3">
            <h3 className="font-semibold text-xl text-black inline-flex gap-2 ">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 7.75H18.1C18.5 7.27 18.75 6.67 18.75 6C18.75 4.48 17.52 3.25 16 3.25C14.32 3.25 12.84 4.14 12 5.46C11.16 4.14 9.68 3.25 8 3.25C6.48 3.25 5.25 4.48 5.25 6C5.25 6.67 5.5 7.27 5.9 7.75H4.5C3.81 7.75 3.25 8.31 3.25 9V11.5C3.25 12.1 3.68 12.58 4.25 12.7V19.5C4.25 20.19 4.81 20.75 5.5 20.75H18.5C19.19 20.75 19.75 20.19 19.75 19.5V12.7C20.32 12.58 20.75 12.1 20.75 11.5V9C20.75 8.31 20.19 7.75 19.5 7.75ZM19.25 11.25H12.75V9.25H19.25V11.25ZM16 4.75C16.69 4.75 17.25 5.31 17.25 6C17.25 6.69 16.69 7.25 16 7.25H12.84C13.18 5.82 14.47 4.75 16 4.75ZM8 4.75C9.53 4.75 10.82 5.82 11.16 7.25H8C7.31 7.25 6.75 6.69 6.75 6C6.75 5.31 7.31 4.75 8 4.75ZM4.75 9.25H11.25V11.25H4.75V9.25ZM5.75 12.75H11.25V19.25H5.75V12.75ZM18.25 19.25H12.75V12.75H18.25V19.25Z"
                  fill="black"
                />
              </svg>{" "}
              {!(formStep === "step3")
                ? " Gift a Bit"
                : "Gift Payment Fee - $10"}
            </h3>
            <Closemodal
              className="w-3.5 h-3.5 fill-black transition-all duration-300 hover:rotate-90 hover:opacity-70"
              setClosePopUp={setGiftBitPopup}
            />
          </div>
          {formStep === "step2" ? (
            <>
              <div className="gap-1 py-3 rounded-md ">
                <div className="gap-1 py-3 rounded-md ">
                  <div className="w-full mb-2">
                    <label
                      htmlFor="recipientEmail"
                      className="block text-sm font-normal text-gray-700 mb-4"
                    >
                      * There's a $10 admin fee to gift your Bit to somebody.
                      Your recipient will receive an invitation to join (if not
                      already a member). When they register on the site using this email address this Bit will be
                      transferred to them.
                    </label>
                    <input
                      id="recipientEmail"
                      type="email"
                      placeholder="Enter recipient's email address..."
                      value={email}
                      // onChange={(e) => setEmail(e.target.value)}
                      onChange={(e) => handleEmailChange(e)}
                      className="w-full p-2 rounded-lg border border-gray-300 bg-white text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div className="gap-1 py-3 rounded-md "></div>

                  {message && (
                    <div className="text-md text-center font-normal text-red-500 mt-4">
                      {message}
                    </div>
                  )}
                  {checkUserData?.is_registered === false && (
                    <>
                      <div className="text-center mt-4">
                        <button
                          className="text-base font-normal text-black rounded-full bg-skyblue hover:bg-skyblue/80 border shadow-Btnshadow border-skyblue px-6 py-2.5 transition-all duration-300"
                          onClick={() => sendInvitationHandle()}
                        >
                          Send Invitation
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="flex items-center justify-end gap-3 !mt-5">
                <button
                  // className="text-base font-normal text-white rounded-full bg-black border border-Cetaceanblue px-8 py-2.5"
                  className="border text-base font-normal text-black/80 hover:text-black rounded-full transition-all duration-300 px-4 py-2"
                  onClick={() => {
                    setGiftBitPopup(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="text-base font-normal text-blackM rounded-full bg-skyblue hover:bg-skyblue/80 border shadow-Btnshadow border-skyblue px-4 py-2 transition-all duration-300"
                  onClick={() => {
                    // setGiftBitPopup(false);
                    handleNext();
                  }}
                >
                  Next
                </button>
              </div>
            </>
          ) : formStep === "step1" ? (
            <>
              <div className="gap-1 py-3 rounded-md ">
                <div className="w-full mb-2">
                  <div className="block text-sm font-medium text-gray-700 mb-2">
                    Choose the Bit you want to gift to somebody :
                  </div>
                  <div className="relative space-y-1">
                    <div className="absolute top-5 right-3">
                      <img src="images/arrowDownGiftBit.svg" alt="arrowimage"/>
                    </div>
                    <select
                      className="w-full p-2 rounded-lg border border-gray-300 bg-white text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none"
                      onChange={handleChange}
                    >
                      <option value="">Select...</option>
                      {loggedUserPurchasedBitInfo &&
                        loggedUserPurchasedBitInfo.map((item: Bit) => (
                          <option key={item.id} value={item.id}>
                            {item.bitdetail?.bit_title}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="gap-1 py-3 rounded-md ">
                  {message && (
                    <div className="text-md text-center font-normal text-red-500 mt-4">
                      {message}!
                    </div>
                  )}
                </div>
              </div>

              <div className="flex items-center justify-end gap-3 !mt-5">
                <button
                  // className="text-base font-normal text-white rounded-full bg-black border border-Cetaceanblue px-8 py-2.5"
                  className="border text-base font-normal text-black/80 hover:text-black rounded-full  transition-all duration-300 px-4 py-2"
                  onClick={() => {
                    setGiftBitPopup(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="text-base font-normal text-blackM rounded-full  bg-skyblue hover:bg-skyblue/80 border shadow-Btnshadow border-skyblue px-4 py-2 transition-all duration-300"
                  onClick={() => {
                    // setGiftBitPopup(false);
                    handleNextStep1();
                  }}
                >
                  Next
                </button>
              </div>
            </>
          ) : formStep === "step3" ? (
            <>
              <p className="text-xs block">
                Enter your Name & Card number. Then click{" "}
                <span className="font-bold">Add Card</span>. Select card &{" "}
                <span className="font-bold">Pay Now</span>.
              </p>
              {stripePromise && (
                <>
                  <Elements stripe={stripePromise}>
                    <GiftBitPaymentForm
                      setFormStep={setFormStep}
                      selectedValue={selectedValue}
                      setPaymentCompleted={setPaymentCompleted}
                      setPaymentFailed={setPaymentFailed}
                      setTransactionId={setTransactionId}
                      setTransactionAmount={setTransactionAmount}
                      receiverUserId={receiverUserId}
                    />
                  </Elements>
                </>
              )}
            </>
          ) : formStep === "step4" ? (
            <>
              {paymentCompleted && transactionId && transactionAmount ? (
                <GiftPaymentsuccessful
                  transactionId={transactionId}
                  transactionAmount={transactionAmount}
                  setPaymentCompleted={setPaymentCompleted}
                  setGiftBitPopup={setGiftBitPopup}
                />
              ) : (
                <Fragment />
              )}
              {paymentFailed ? (
                <Paymentfailed setPaymentFailed={setPaymentFailed} />
              ) : (
                <Fragment />
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};
